import comp from "./BenchmarkView";
export default comp;
